import React from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { config } from "../../api/client";
import SubmissionFilePreview from "../../components/Dashboard/SubmissionFilePreview";

/**
 * Standalone, full-page viewer for an uploaded submission/assignment file.
 * Opened in a new tab from the instructor grading screen (and the student
 * grades page). The file is only ever fetched through the authenticated
 * `submissions/{id}/file` route — see SubmissionFilePreview.
 */
export default function SubmissionViewerPage() {
  const { submissionId } = useParams();
  const [searchParams] = useSearchParams();
  const name = searchParams.get("name") || "";

  const submission = {
    id: submissionId,
    file_original_name: name,
    file_download_url: `${config.baseURL}/submissions/${submissionId}/file`,
  };

  return (
    <div className="min-h-screen bg-[#f4f6f9]">
      <header className="bg-white border-b border-gray-200 px-4 md:px-8 py-4">
        <p className="text-[11px] font-semibold text-gray-400 uppercase tracking-wider">Submission file</p>
        <h1 className="text-base font-bold text-gray-900 truncate">{name || `Submission #${submissionId}`}</h1>
      </header>
      <main className="max-w-6xl mx-auto p-4 md:p-8">
        <SubmissionFilePreview submission={submission} tall />
      </main>
    </div>
  );
}
